import React, { useState, useRef, useContext } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import Bag from "./Bag";
import { UserContext } from './UserContext'; // Import UserContext

const BagsList = ({ bagsStatus, handleBagSelection, selectedBags, handleButtonClick }) => {
  const checkboxesRef = useRef([]);
  const [revealedBags, setRevealedBags] = useState({});
  const { user } = useContext(UserContext); // Access user data from context

  // Toggles the visibility of a specific bag's ID
  const handleToggle = (bagId) => {
    setRevealedBags((prevRevealedBags) => ({
      ...prevRevealedBags,
      [bagId]: !prevRevealedBags[bagId],
    }));
  };

  const handleButtonClick2 = (bagId) => {
    if (checkboxesRef.current[bagId]) {
      checkboxesRef.current[bagId].click();
    }
  };

  return (
    <div className="container">
      <div className="row">
        {bagsStatus.map((bag) => (
          <div
            key={bag.id}
            style={{
              position: "relative",
              background: "transparent",
              padding: "0",
              border: "none",
              padding: "10px"
            }}
            className="col-lg-3"
          >
            <div className="text-center" style={{ backgroundColor: "#ffffff", border: "1px solid #e0e0e0", borderRadius: "8px", transition: "box-shadow 0.3s ease", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", padding: "20px" }}>
              <center><Bag /></center>
              <div>
                <span color="white" style={{ color: "black", fontSize: "16px" }} onClick={() => handleToggle(bag.id)}>
                  {/* Display the full ID if revealed, else show last 4 digits */}
                  {revealedBags[bag.id] ? bag.id : bag.id.slice(-4).padStart(bag.id.length, '*')}
                  {" "}
                  {revealedBags[bag.id] ? <FaEyeSlash color="black" /> : <FaEye color="black" />}
                </span>
                <input
                  style={{ margin: "10px" }}
                  type="checkbox"
                  ref={(el) => (checkboxesRef.current[bag.id] = el)}
                  checked={selectedBags.includes(bag.id)}
                  onChange={() => handleBagSelection(bag.id)}
                  disabled={bag.inOrder} // Disable if bag is in order
                />
                <span style={{ opacity: "0.9", color: "grey", marginLeft: "10px", fontSize: "16px" }}>
                  {bag.inOrder ? "In use." : ""}
                </span>
              </div>
              <button
                onClick={() => handleButtonClick2(bag.id)}
                style={{ margin: "auto", marginTop: "10px", background: "#d3d4d5", color: "black", border: ".1px solid #ccc", width: "200px" }}
              >
                Select
              </button>
              {/* Example usage of user context */}
              {user && false && (
                <div style={{ marginTop: "10px", color: "blue" }}>
                  <p>Welcome, {user.name}!</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BagsList;
